import { configAxios, getAxiosConfig } from 'services/apiConfig';
import { createLog } from 'services/logService';

export const createOrder = async (params) => {
  try {
    params.accommodations.forEach((a) => {
      a.startDate = new Date(a.startDate.setHours(0, 0, 0, 0)).toISOString();
      a.endDate = new Date(a.endDate.setHours(0, 0, 0, 0)).toISOString();
    });
    params.courses.forEach((c) => {
      c.startDate = new Date(c.startDate.setHours(0, 0, 0, 0)).toISOString();
    });

    const response = await configAxios.post(`abroad`, params);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getOrder = async (hash) => {
  try {
    const response = await configAxios.get(`abroad/${hash}`);
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: error.response.status,
    };
  }
};

export const getAbroadBilling = async (hash) => {
  try {
    const response = await configAxios.get(`abroad/${hash}`);

    return response.data;
  } catch (error) {
    return {
      status: error.response.status,
    };
  }
};

export const getAbroadStudent = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);
    const response = await config.get(`abroad/abroad`, { params: req.query });
    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getAbroadStudentEmail = async (req, res) => {
  const config = await getAxiosConfig(req, res);
  const { email } = req.query;

  try {
    const response = await config.get(`abroad/abroad/expert?email=${email}`);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getInsuranceQuote = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);
    const response = await config.get(`abroad/insurance/quote`, {
      params: req.query,
    });

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getAbroadLocation = async (hash) => {
  try {
    const response = await configAxios.get(`abroad/location/${hash}`);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const createAbroadInsurance = async (req, res) => {
  const config = await getAxiosConfig(req, res);
  const response = await config.post(`abroad/insurance`, {
    ...req.body,
  });

  return response.data;
};

export const getAbroad = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);
    const response = await config.get('abroads');

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};
